import { filterIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Filter = createIcon({
  displayName: 'Filter',
  d: 'M896 256h-768c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h768c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM725.333 554.667h-426.667c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h426.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM554.667 853.333h-85.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h85.333c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z',
  canvasPaths: canvasIconPaths(filterIcon)
})
